import React from 'react';
import ResponsiveImage from './ResponsiveImage';
import ResponsiveVideo from './ResponsiveVideo';
import { isGalleryVideoUrl } from '../utils/galleryMedia';

/**
 * Single hero / carousel slide — image or muted inline video.
 */
export default function GallerySlideMedia({
  src,
  alt = '',
  className = '',
  variant = 'hero',
  priority = false,
  active = true,
  poster,
  deliveryWidth = 720
}) {
  if (!src) return null;

  if (isGalleryVideoUrl(src)) {
    return (
      <ResponsiveVideo
        src={src}
        poster={poster}
        deliveryWidth={deliveryWidth}
        className={className}
        muted
        playsInline
        autoPlay={active}
        loop
        preload={active ? 'auto' : 'metadata'}
        disablePictureInPicture
        aria-label={alt}
      />
    );
  }

  return (
    <ResponsiveImage
      src={src}
      variant={variant}
      priority={priority}
      alt={alt}
      className={className}
    />
  );
}
